import React from 'react';
import PropTypes from 'prop-types';

const ProductPrice = ({ prefix, price }) => (
  <span>
    {prefix ? `${prefix} ` : ''}
    {price}
  </span>
);

ProductPrice.propTypes = {
  prefix: PropTypes.string,
  price: PropTypes.string
};

ProductPrice.defaultProps = {
  prefix: '',
  price: ''
};

export default ProductPrice;
